import Swiper from 'swiper'
if (window.innerWidth <= 1024) {
  const containers = document.querySelectorAll('.mosaic-container')
  containers.forEach(container => {
    if (container.classList.contains('in-backend')) {
        return;
    }
    new Swiper(container, {
      slidesPerView: 1.3,
      slideClass: 'mosaic-grid',
      wrapperClass: 'mosaic',
    })
  })
}



const videos = document.querySelectorAll('.mosaic-video')
videos.forEach(videoContainer => {
    videoContainer.addEventListener('click', function() {
        const video = videoContainer.querySelector('video');
        const playButton = videoContainer.querySelector('.mosaic-play');
        if (video.paused) {
            playButton.classList.add('mosaic-play-hidden');
            video.play();
        } else {
            playButton.classList.remove('mosaic-play-hidden');
            video.pause();
        }
    });
});